import { render, staticRenderFns } from "./autoReport.vue?vue&type=template&id=01955f06&scoped=true&"
import script from "./autoReport.vue?vue&type=script&lang=js&"
export * from "./autoReport.vue?vue&type=script&lang=js&"
import style0 from "./autoReport.vue?vue&type=style&index=0&id=01955f06&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01955f06",
  null
  
)

export default component.exports